import { FETCH_PAYMENT_METHODS, GET_USER, GET_USER_INFORMATION } from "./actions"
import { PaginatedData } from "../../types/root"
import { ArtistsKahunaActionProps, ArtistsKahunaProps, PaymentMethod } from "types/artists-kahuna"
import UserInformation from "pages/offers/deals/user-information/UserInformation"

export const initialArtistsKahunaState: ArtistsKahunaProps = {
  paginatedPaymentMethodList: new PaginatedData<PaymentMethod>(),
  userInformation: undefined,
  artistKahunaUser: undefined
}

const artistsKahuna = (state = initialArtistsKahunaState, action: ArtistsKahunaActionProps) => {
  switch (action.type) {
    case FETCH_PAYMENT_METHODS: {
      const paginatedPaymentMethodList =
        (action.payload?.paginatedPaymentMethodList as PaginatedData<PaymentMethod>) ||
        new PaginatedData<PaymentMethod>()
      return {
        ...state,
        paginatedPaymentMethodList
      }
    }
    case GET_USER_INFORMATION: {
      const userInformation = action.payload?.userInformation
      return {
        ...state,
        userInformation
      }
    }
    case GET_USER: {
      const artistKahunaUser = action.payload?.artistKahunaUser
      return {
        ...state,
        artistKahunaUser
      }
    }
    default: {
      return { ...state }
    }
  }
}

export default artistsKahuna
